// Auth
export * from './useAuth';
export * from './useSocialAuth';

// Courses
export * from './useCourses';

// Enrollments
export * from './useEnrollments';

// Access Groups
export * from './useAccessGroups';

// Progress
export * from './useProgress';

// Gamification
export * from './useGamification';

// Certificates
export * from './useCertificates';

// Quizzes
export * from './useQuizzes';

// Media
export * from './useMedia';

// Comments
export * from './useComments';

// Reactions
export * from './useReactions';

// Member Areas (Banners, Menus)
export * from './useMemberAreas';

// Settings
export * from './useSettings';

// Email Templates
export * from './useEmailTemplates';

// Webhooks
export * from './useWebhooks';

// Analytics
export * from './useAnalytics';

// Course Sections
export * from './useCourseSections';

// Course Appearance (page builder + per-course sidebar)
export * from './appearance';

// Notifications
export * from './useNotifications';

// Stubs for level CRUD mutations (not yet in gamificationService hooks)
export function useCreateLevel() {
  return {
    mutate: () => console.log('Create level stub'),
    mutateAsync: async () => {
      console.log('Create level stub async');
      return Promise.resolve();
    },
    isLoading: false,
  };
}

export function useUpdateLevel() {
  return {
    mutate: () => console.log('Update level stub'),
    mutateAsync: async () => {
      console.log('Update level stub async');
      return Promise.resolve();
    },
    isLoading: false,
  };
}

export function useDeleteLevel() {
  return {
    mutate: (_id?: string) => console.log('Delete level stub'),
    mutateAsync: async (_id?: string) => {
      console.log('Delete level stub async');
      return Promise.resolve();
    },
    isLoading: false,
    isPending: false,
  };
}
